module.exports = __webpack_public_path__ + "static/media/verhaltensbasiert_step_5.de1b9580.png";